<template>
  <MaterialCard>
    <!-- TODO: reimplement this chart-->
    <!-- <material-chart-card
      v-if="visible"
      class="graph"
      type="Line"
      :data="chartData"
      :options="chartOptions"
    /> -->
    グラフ
  </MaterialCard>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    records: {
      type: Array,
      default: () => []
    },
    tank: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    visible: false,
    chartOptions: {
      lineSmooth: false,
      low: 0,
      high: 550,
      chartPadding: {
        top: 30,
        right: 0,
        bottom: 0,
        left: 0
      }
    }
  }),
  computed: {
    chartData () {
      const records = this.records.concat().sort((a, b) => a.timestamp - b.timestamp)
      return {
        labels: records.map(r => moment(r.timestamp * 1000).format('M/D')),
        series: [
          records.map(r => 490 - r.data[0])
        ]
      }
    }
  },
  methods: {
    draw () {
      this.visible = true
    }
  }
}
</script>

<style>
.graph {
  height: 60%
}
</style>
